import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { motion } from "framer-motion";
import { useAuth } from "@/contexts/AuthContext";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      const detail = err.response?.data?.detail;
      setError(typeof detail === "string" ? detail : "Invalid credentials");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-ivory flex items-center justify-center px-6">
      <motion.div
        initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1.0, ease: [0.16, 1, 0.3, 1] }}
        className="w-full max-w-md"
      >
        <Link to="/" className="block text-center mb-10">
          <p className="overline text-rose">Tammy's Treats</p>
          <h1 className="font-display text-4xl text-ink mt-4">Studio Login</h1>
        </Link>
        <div className="hairline w-24 mx-auto mb-12" />
        <form onSubmit={onSubmit} className="space-y-8" data-testid="login-form">
          <div>
            <label className="overline">Email</label>
            <input type="email" required className="elegant-input" value={email} onChange={e => setEmail(e.target.value)} data-testid="login-email" />
          </div>
          <div>
            <label className="overline">Password</label>
            <input type="password" required className="elegant-input" value={password} onChange={e => setPassword(e.target.value)} data-testid="login-password" />
          </div>
          {error && <p className="text-sm text-destructive" data-testid="login-error">{error}</p>}
          <button type="submit" disabled={loading} className="btn-rose w-full" data-testid="login-submit">
            {loading ? "Signing in…" : "Sign In"}
          </button>
        </form>
        <Link to="/" className="block text-center mt-10 text-xs uppercase tracking-[0.2em] text-ink-soft elegant-link">← Back to site</Link>
      </motion.div>
    </div>
  );
}
